// TeluguBooks Wishlist - localStorage based
(function() {
  var STORAGE_KEY = 'tb_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch(e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isWishlisted(id) {
    return getWishlist().indexOf(String(id)) > -1;
  }

  function toggleWishlist(id, variantId, title, image, url, price) {
    var list = getWishlist();
    var sid = String(id);
    var idx = list.indexOf(sid);
    if (idx > -1) {
      list.splice(idx, 1);
      saveWishlist(list);
      var meta = getWishlistMeta();
      delete meta[sid];
      saveWishlistMeta(meta);
    } else {
      list.push(sid);
      saveWishlist(list);
      var meta = getWishlistMeta();
      meta[sid] = { variantId: variantId, title: title, image: image, url: url, price: price };
      saveWishlistMeta(meta);
    }
    updateAllButtons(sid);
    renderDrawer();
    updateCount();
  }

  function getWishlistMeta() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY + '_meta')) || {}; }
    catch(e) { return {}; }
  }

  function saveWishlistMeta(meta) {
    localStorage.setItem(STORAGE_KEY + '_meta', JSON.stringify(meta));
  }

  function updateAllButtons(id) {
    var btns = document.querySelectorAll('.tb-wishlist-btn[data-product-id="' + id + '"]');
    btns.forEach(function(btn) {
      if (isWishlisted(id)) {
        btn.classList.add('wishlisted');
        btn.setAttribute('title', 'Remove from Wishlist');
      } else {
        btn.classList.remove('wishlisted');
        btn.setAttribute('title', 'Add to Wishlist');
      }
    });
  }

  function updateCount() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('.tb-wishlist-count');
    badges.forEach(function(b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'inline-block' : 'none';
    });
  }

  function renderDrawer() {
    var list = getWishlist();
    var meta = getWishlistMeta();
    var container = document.getElementById('tb-wishlist-items');
    if (!container) return;
    if (list.length === 0) {
      container.innerHTML = '<p class="tb-wishlist-empty">Your wishlist is empty.</p>';
      return;
    }
    var html = '';
    list.forEach(function(id) {
      var item = meta[id];
      if (!item) return;
      html += '<div class="tb-wishlist-item" data-id="' + id + '">' +
        '<a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.title + '"></a>' +
        '<div class="tb-wishlist-item-info">' +
          '<a href="' + item.url + '">' + item.title + '</a>' +
          '<span class="tb-wishlist-item-price">' + item.price + '</span>' +
        '</div>' +
        '<button class="tb-wishlist-remove" data-id="' + id + '" title="Remove">✕</button>' +
      '</div>';
    });
    container.innerHTML = html;

    container.querySelectorAll('.tb-wishlist-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = this.getAttribute('data-id');
        var m = getWishlistMeta();
        var item = m[id] || {};
        // ✅ Fixed: pass variantId correctly
        toggleWishlist(id, item.variantId, item.title, item.image, item.url, item.price);
      });
    });
  }

  function renderCartWishlist() {
    var container = document.getElementById('tb-cart-wishlist-items');
    if (!container) return;
    var list = getWishlist();
    var meta = getWishlistMeta();
    if (list.length === 0) {
      container.innerHTML = '<p>Your wishlist is empty.</p>';
      return;
    }
    var html = '';
    list.forEach(function(id) {
      var item = meta[id];
      if (!item) return;
      // ✅ Fixed: use item.variantId instead of id
      html += '<div class="tb-cart-wishlist-item">' +
        '<a href="' + item.url + '"><img src="' + item.image + '" alt="' + item.title + '"></a>' +
        '<div class="tb-cart-wishlist-item-info">' +
          '<a href="' + item.url + '">' + item.title + '</a>' +
          '<span>' + item.price + '</span>' +
          '<button class="tb-cart-add-btn" data-variant-id="' + item.variantId + '" data-title="' + item.title + '">Add to Cart</button>' +
        '</div>' +
      '</div>';
    });
    container.innerHTML = html;

    container.querySelectorAll('.tb-cart-add-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = this.getAttribute('data-variant-id');
        var self = this;
        self.disabled = true;
        self.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.id) {
            self.textContent = '✓ Added!';
            self.style.background = '#4CAF50';
            setTimeout(function() { window.location.reload(); }, 800);
          } else {
            self.textContent = 'Error';
            self.disabled = false;
          }
        })
        .catch(function() {
          self.textContent = 'Error';
          self.disabled = false;
        });
      });
    });
  }

  function initButtons() {
    document.querySelectorAll('.tb-wishlist-btn').forEach(function(btn) {
      var id = btn.getAttribute('data-product-id');
      if (isWishlisted(id)) {
        btn.classList.add('wishlisted');
        btn.setAttribute('title', 'Remove from Wishlist');
      }
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var id = this.getAttribute('data-product-id');
        // ✅ Fixed: pass variantId from data attribute
        var variantId = this.getAttribute('data-variant-id');
        var title = this.getAttribute('data-title');
        var image = this.getAttribute('data-image');
        var url = this.getAttribute('data-url');
        var price = this.getAttribute('data-price');
        toggleWishlist(id, variantId, title, image, url, price);
      });
    });
  }

  function initDrawer() {
    var toggle = document.getElementById('tb-wishlist-toggle');
    var drawer = document.getElementById('tb-wishlist-drawer');
    var overlay = document.getElementById('tb-wishlist-overlay');
    var close = document.getElementById('tb-wishlist-close');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function() {
      drawer.classList.toggle('open');
      overlay.classList.toggle('open');
      renderDrawer();
    });
    if (close) close.addEventListener('click', function() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
    });
    if (overlay) overlay.addEventListener('click', function() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initButtons();
    initDrawer();
    updateCount();
    renderCartWishlist();
  });

  window.TBWishlist = { toggle: toggleWishlist, isWishlisted: isWishlisted };
})();
